import { resetPassword } from "@/services/passport/passport.service"
import { Button, Form, Input } from "antd"
import { useNavigate, useParams } from "react-router"
import md5 from 'blueimp-md5'


export const ResetPassword = () => {
  const nav = useNavigate()
  const [form] = Form.useForm()
  const params = useParams()

  const toLogin = () => {
    nav('/login')
  }

  const reset = async (values) => {
    const valid = await form.validateFields()
    if (valid) {
      const {password, rep_password} = values;
      if (password !== rep_password) {
        return
      }
      if (params.token) {
        await resetPassword(md5(password), params.token)
        toLogin()
      }
    }
  }

  return <Form form={form}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={reset}
    >
    <Form.Item
      name='password'
      label='New Password'
      rules={[
        {
          required: true,
          message: 'Please input your password!',
        },
      ]}
    >
      <Input.Password />
    </Form.Item>
    <Form.Item
      name='rep_password'
      label='Repeat Password'
      dependencies={['password']}
      hasFeedback
      rules={[
        {
          required: true,
          message: 'Please confirm your password!',
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue('password') === value) {
              return Promise.resolve();
            }
            return Promise.reject(new Error('The new password that you entered do not match!'));
          },
        }),
      ]}
    >
      <Input.Password />
    </Form.Item>
    <div className="flex-center mt-2">
      <Button type="primary" htmlType="submit" style={{width: '80%'}}>
        Reset
      </Button>
    </div>
    <div className="flex-center mt-2">
      <Button onClick={toLogin} style={{width: '80%'}}>
        To Login
      </Button>
    </div>
    
  </Form>
}